import Box from '@zenbusiness/zui/Box';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { SectionWrapper } from '../SectionWrapper';

export default function EmptyTransaction() {
  return (
    <SectionWrapper gap="8px">
      <Text
        size="lg"
        weight="medium"
      >
        Transactions
      </Text>
      <Stack alignItems="center">
        <Box>
          <SharedAsset
            alt="No transactions"
            height={80}
            src="/s2/vector/transactions-inactive.svg"
            width={80}
          />
        </Box>
        <Text
          align="center"
          size="md"
        >
          You don&apos;t have any transactions yet
        </Text>
      </Stack>
    </SectionWrapper>
  );
}
